export const errorMessages: Record<string, string> = {
  GLOBAL_SERVICE_NOT_FOUND:
    'Unable to find the selected pairing. This is an unexpected error. Please try again or contact support.',
  GLOBAL_SERVICE_DELETED:
    'This pairing of Data Source and Action is not supported anymore. Please select another Action.',
  BUSINESS_SERVICE_EXISTS:
    'This service already exists for this business. Change the unique identifier or the data source and action pairing.',
};
